/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Fordersumme (Fördersumme)
 * 
 * 401130001 = Gesamtprojektsumme (Gesamtprojektsumme)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceBerechnungsmethode {
 Fordersumme = 401130000,
 Gesamtprojektsumme = 401130001
}

marker([
    "Enum.GlobalEnumsAceBerechnungsmethode.Fordersumme",
    "Enum.GlobalEnumsAceBerechnungsmethode.Gesamtprojektsumme"
]);

export namespace GlobalEnumsAceBerechnungsmethode
{
    class DataSets
    {
        static GlobalEnumsAceBerechnungsmethodeDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Fordersumme", 401130000, "Fördersumme"),
            new EnumValue("Gesamtprojektsumme", 401130001, "Gesamtprojektsumme"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceBerechnungsmethodeDataSet;
    }
}
